module.exports = __webpack_public_path__ + "img/uzbekistan.3ef7ddb.webp";